import React from "react";
import { FaTint, FaThermometerHalf, FaFlask } from "react-icons/fa";

const MarkerLabel = ({ medida, active }) => {
  if (!medida) {
    return (
      <div
        className="marker-tooltip"
        style={{
          position: "absolute",
          top: "-10px",
          left: "50%",
          transform: "translate(-50%, -100%)",
          backgroundColor: "white",
          padding: "6px 10px",
          borderRadius: "6px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          zIndex: active ? 3000 : 1001,
          whiteSpace: "nowrap",
          fontSize: "12px",
          border: "1px solid rgba(28, 66, 32, 0.3)",
          color: "#555",
          opacity: active ? 1 : 0.9,
          minWidth: "120px",
        }}
      >
        <div className="text-center">Sem medida recente</div>
        <div
          style={{
            position: "absolute",
            bottom: "-6px",
            left: "50%",
            transform: "translateX(-50%) rotate(45deg)",
            width: "12px",
            height: "12px",
            backgroundColor: "white",
            borderRight: "1px solid rgba(28, 66, 32, 0.3)",
            borderBottom: "1px solid rgba(28, 66, 32, 0.3)",
          }}
        />
      </div>
    );
  }

  return (
    <div
      className="marker-tooltip"
      style={{
        position: "absolute",
        top: "-12px",
        left: "50%",
        transform: "translate(-50%, -100%)",
        backgroundColor: "white",
        padding: "8px 12px",
        borderRadius: "8px",
        boxShadow: active ? "0 4px 12px rgba(143, 173, 21, 0.5)" : "0 2px 8px rgba(0,0,0,0.15)",
        zIndex: active ? 3000 : 1001,
        whiteSpace: "nowrap",
        fontSize: "12px",
        border: active ? "2px solid #8fad15" : "1px solid rgba(28, 66, 32, 0.2)",
        width: "160px",
        color: "#1c4220",
        animation: active ? "tooltip-pulse 2s infinite alternate" : "none",
      }}
    >
      <div className="d-flex flex-column gap-1">
        {medida.grain && (
          <div 
            className="grain-type text-center mb-1 fw-bold"
            style={{
              backgroundColor: "rgba(143, 173, 21, 0.1)",
              borderRadius: "4px",
              padding: "3px 5px",
              color: "#1c4220",
              fontSize: "11px",
            }}
          >
            {medida.grain?.toUpperCase()}
          </div>
        )}
        
        <div className="d-flex justify-content-between align-items-center">
          <div 
            className="d-flex align-items-center"
            style={{
              color: "#1c4220",
            }}
          >
            <FaTint 
              style={{ 
                marginRight: "5px", 
                color: "#8fad15", 
              }} 
            /> 
            <span className="fw-bold">Umidade:</span>
          </div>
          <div className="fw-semibold">{medida.umidade ?? medida.humidity} %</div>
        </div>
        
        {(medida.ph || medida.ph === 0) && (
          <div className="d-flex justify-content-between align-items-center">
            <div 
              className="d-flex align-items-center"
              style={{
                color: "#1c4220",
              }}
            >
              <FaFlask 
                style={{ 
                  marginRight: "5px", 
                  color: "#8fad15", 
                }} 
              /> 
              <span className="fw-bold">PH:</span>
            </div>
            <div className="fw-semibold">{medida.ph}</div>
          </div>
        )}
        
        {medida.temperature && (
          <div className="d-flex justify-content-between align-items-center">
            <div 
              className="d-flex align-items-center"
              style={{
                color: "#1c4220",
              }}
            >
              <FaThermometerHalf 
                style={{ 
                  marginRight: "5px", 
                  color: "#8fad15", 
                }} 
              /> 
              <span className="fw-bold">Temp:</span>
            </div>
            <div className="fw-semibold">{medida.temperature} °C</div>
          </div>
        )}
      </div>
      
      <div
        style={{
          position: "absolute",
          bottom: "-8px",
          left: "50%",
          transform: "translateX(-50%) rotate(45deg)",
          width: "16px",
          height: "16px",
          backgroundColor: "white",
          borderRight: active ? "2px solid #8fad15" : "1px solid rgba(28, 66, 32, 0.2)",
          borderBottom: active ? "2px solid #8fad15" : "1px solid rgba(28, 66, 32, 0.2)",
          zIndex: -1,
        }}
      />
      
      <style jsx="true">{`
        @keyframes tooltip-pulse {
          from {
            box-shadow: 0 4px 12px rgba(143, 173, 21, 0.3);
          }
          to {
            box-shadow: 0 4px 18px rgba(143, 173, 21, 0.7);
          }
        }
      `}</style>
    </div>
  );
};

export default MarkerLabel;
